import Vue from "vue";
import autosize from "autosize";

Vue.directive("focus", {
  inserted: function(el) {
    el.focus();
  }
});

Vue.directive("autosize", {
  bind: function(el) {
    Vue.nextTick(function() {
      autosize(el);
    });
  },

  update: function(el) {
    Vue.nextTick(function() {
      autosize.update(el);
    });
  },

  unbind: function(el) {
    autosize.destroy(el);
  }
});
